import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
// import { ServiceWorkerModule } from '@angular/service-worker';
// ui boosts
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTreeModule } from '@angular/cdk/tree';
import { FullCalendarModule } from '@fullcalendar/angular'; 
import { NgxMaskModule, IConfig } from 'ngx-mask';

// Mtic3 App Modules
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { UiLandingModule } from './ui-landing/ui-landing.module';
import { UiWhitelabelDemoModule } from './ui-whitelabel-demo/ui-whitelabel-demo.module';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';
import { UiTestrunnerModule } from './ui-testrunner/ui-testrunner.module';
import { UiTestadminModule } from './ui-testadmin/ui-testadmin.module';
import { UiLoginModule } from './ui-login/ui-login.module';
import { UiTransModule } from './ui-trans/ui-trans.module';
import { UiPartialModule } from './ui-partial/ui-partial.module';


export const ngMarkDownOptions = {
  markedOptions: {
    provide: MarkedOptions,
    useValue: {
      gfm: true,
      tables: true,
      breaks: false,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: false,
    },
  },
}
export const ngMaskOption: Partial<IConfig> | (() => Partial<IConfig>) = {};

// IMPORTANT
// Add your own project credentials to environments/*.ts

@NgModule({
  declarations: [
    AppComponent
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserTransferStateModule,
    AppRoutingModule,
    HttpClientModule,

    CoreModule,
    UiLandingModule,
    UiPartialModule,
    UiTestrunnerModule,
    UiTestadminModule,
    UiLoginModule,
    UiTransModule,
    
    UiWhitelabelDemoModule,

    NgxMaskModule.forRoot(ngMaskOption),
    MarkdownModule.forRoot(ngMarkDownOptions),
    
    FullCalendarModule,
    DragDropModule,
    CdkTreeModule,

    // ServiceWorkerModule.register('/ngsw-worker.js', {
    //   enabled: environment.production
    // })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
